export default __webpack_public_path__ + "static/partner12-d16f01a171fd2ac7142f93ddebfbc15b.jpg";